"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var initial_exports = {};
__export(initial_exports, {
  initialBlockState: () => initialBlockState,
  initialCardState: () => initialCardState,
  initialDynamicGridState: () => initialDynamicGridState,
  initialDynamicImageState: () => initialDynamicImageState,
  initialDynamicValueState: () => initialDynamicValueState,
  initialFieldState: () => initialFieldState,
  initialFormState: () => initialFormState,
  initialFullWidthState: () => initialFullWidthState,
  initialGroupState: () => initialGroupState,
  initialHeadingState: () => initialHeadingState,
  initialPageState: () => initialPageState,
  initialPrimarySurveyorFieldState: () => initialPrimarySurveyorFieldState,
  initialPrimaryTeamFieldState: () => initialPrimaryTeamFieldState,
  initialRepeatState: () => initialRepeatState,
  initialRepeatStateFromArray: () => initialRepeatStateFromArray,
  initialRequireRoleState: () => initialRequireRoleState,
  initialScopeState: () => initialScopeState,
  initialTextState: () => initialTextState,
  initialVisibilityState: () => initialVisibilityState
});
module.exports = __toCommonJS(initial_exports);
var import_topo_core = require("@cartographerio/topo-core");
var import_topo_survey = require("@cartographerio/topo-survey");
var import_fp = require("@cartographerio/fp");
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_rule = require("../rule/index.js");
var import_image = require("./image.js");
var import_message = require("./message.js");
var import_required = require("../required.js");
var import_run = require("../expr/run.js");
function initialFieldState(block, parentEnv) {
  const env = parentEnv.focus(block.path);
  const absolutePath = env.expand([]);
  const value = env.getFocused();
  const image = (0, import_image.fieldImage)(block, value);
  const required = (0, import_required.fieldIsRequired)(block);
  const messages = (0, import_rule.runRules)(block, env);
  const counts = (0, import_message.messageCounts)(messages);
  const highlight = (0, import_message.messageHighlight)(counts);
  const visible = (0, import_run.optTopoEval)(block.visible, parentEnv).getOrUndefined() ?? true;
  return {
    type: "FieldState",
    absolutePath,
    field: block,
    value,
    image,
    required,
    visible,
    messages,
    highlight,
    ...counts
  };
}
function initialCardState(block, parentSchema, parentEnv) {
  return {
    type: "CardState",
    block,
    childState: initialBlockState(block.block, parentSchema, parentEnv)
  };
}
function initialDynamicValueState(block, parentEnv) {
  return {
    type: "DynamicValueState",
    block,
    attribute: (0, import_run.topoEval)(block.value, parentEnv).map((value) => ({
      label: block.label,
      valueType: block.valueType,
      units: block.units,
      decimalPlaces: block.decimalPlaces,
      value,
      error: null
    })).getOrElse((message) => ({
      label: block.label,
      valueType: block.valueType,
      units: block.units,
      decimalPlaces: block.decimalPlaces,
      value: null,
      error: `${message}`
    }))
  };
}
function initialDynamicGridState(block, parentEnv) {
  return {
    type: "DynamicGridState",
    block,
    attributes: block.attributes.map(
      (attribute) => (0, import_run.topoEval)(attribute.value, parentEnv).map((value) => ({
        label: attribute.label,
        valueType: attribute.valueType,
        units: attribute.units,
        decimalPlaces: attribute.decimalPlaces,
        value,
        error: null
      })).getOrElse((message) => ({
        label: attribute.label,
        valueType: attribute.valueType,
        units: attribute.units,
        decimalPlaces: attribute.decimalPlaces,
        value: null,
        error: `${message}`
      }))
    )
  };
}
function initialDynamicImageState(block, parentEnv) {
  const urlResult = (0, import_run.topoEval)(block.url, parentEnv).mapError(String);
  const captionResult = (0, import_run.optTopoEval)(block.caption, parentEnv).mapError(
    String
  );
  return {
    type: "DynamicImageState",
    block,
    url: urlResult.getOrNull(),
    urlError: urlResult.swap().getOrNull(),
    caption: captionResult?.getOrNull(),
    captionError: captionResult?.swap().getOrNull()
  };
}
function initialHeadingState(block) {
  return { type: "HeadingState", block };
}
function initialTextState(block, parentEnv) {
  return {
    type: "TextState",
    visible: (0, import_run.optTopoEval)(block.visible, parentEnv).getOrUndefined() ?? true,
    block
  };
}
function initialGroupState(block, parentSchema, parentEnv) {
  return {
    type: "GroupState",
    block,
    blockStates: block.blocks.map((b) => initialBlockState(b, parentSchema, parentEnv))
  };
}
function initialRepeatStateFromArray(block, arraySchema, arrayEnv) {
  const arrayPath = arrayEnv.expand([]);
  const arrayValue = arrayEnv.getFocusedAs(import_guard.isArray).mapError(() => (0, import_types.internalError)("Data for repeat block isn't an array")).getOrThrow();
  const childSchema = arraySchema?.param;
  const childStates = arrayValue.map(
    (_value, index) => initialBlockState(block.block, childSchema, arrayEnv.focus([index]))
  );
  return { type: "RepeatState", block, arrayPath, arraySchema, childStates };
}
function initialRepeatState(block, parentSchema, parentEnv) {
  const arraySchema = import_fp.Option.wrap(parentSchema).nullMap((s) => (0, import_topo_survey.schemaRef)(s, block.path)).guard((value) => (0, import_topo_survey.isSchema)(value) && (0, import_topo_survey.isArraySchema)(import_topo_survey.isAnySchema)(value)).getOrThrow(() => new Error("Schema for repeat block isn't an array"));
  const arrayEnv = parentEnv.focus(block.path);
  return initialRepeatStateFromArray(block, arraySchema, arrayEnv);
}
function initialRequireRoleState(block, parentSchema, parentEnv) {
  return {
    type: "RequireRoleState",
    block,
    childState: initialBlockState(block.block, parentSchema, parentEnv)
  };
}
function initialScopeState(block, parentSchema, parentEnv) {
  const schema = import_fp.Option.wrap(parentSchema).nullMap((schema2) => (0, import_topo_survey.schemaRef)(schema2, block.path)).getOrThrow(() => new Error("Repeat schema not found"));
  const env = parentEnv.focus(block.path);
  return {
    type: "ScopeState",
    block,
    childState: initialBlockState(block.block, schema, env)
  };
}
function initialFullWidthState(block, parentSchema, parentEnv) {
  return {
    type: "FullWidthState",
    block,
    childState: initialBlockState(block.block, parentSchema, parentEnv)
  };
}
function initialVisibilityState(block, parentSchema, parentEnv) {
  return {
    type: "VisibilityState",
    visible: (0, import_run.topoEval)(block.visible, parentEnv).getOrUndefined() ?? true,
    block,
    childState: initialBlockState(block.block, parentSchema, parentEnv)
  };
}
function initialPrimarySurveyorFieldState(field, _parentSchema, parentEnv) {
  const messages = field.rule(parentEnv);
  const counts = (0, import_message.messageCounts)(messages);
  return {
    type: "PrimarySurveyorFieldState",
    field,
    messages,
    surveyor: parentEnv.getAbsoluteAs(["surveyor"], import_types.isUserRef).getOrNull(),
    teamId: parentEnv.getAbsoluteAs(["teamId"], import_types.isTeamId).getOrNull(),
    ...counts,
    highlight: (0, import_message.messageHighlight)(counts)
  };
}
function initialPrimaryTeamFieldState(field, _parentSchema, parentEnv) {
  const messages = field.rule(parentEnv);
  const counts = (0, import_message.messageCounts)(messages);
  return {
    type: "PrimaryTeamFieldState",
    field,
    messages,
    surveyor: parentEnv.getAbsoluteAs(["surveyor"], import_types.isUserRef).getOrNull(),
    teamId: parentEnv.getAbsoluteAs(["teamId"], import_types.isTeamId).getOrNull(),
    ...counts,
    highlight: (0, import_message.messageHighlight)(counts)
  };
}
function initialBlockState(block, parentSchema, parentEnv) {
  switch (block.type) {
    case "Card":
      return initialCardState(block, parentSchema, parentEnv);
    case "DynamicValue":
      return initialDynamicValueState(block, parentEnv);
    case "DynamicGrid":
      return initialDynamicGridState(block, parentEnv);
    case "DynamicImage":
      return initialDynamicImageState(block, parentEnv);
    case "FullWidth":
      return initialFullWidthState(block, parentSchema, parentEnv);
    case "Heading":
      return initialHeadingState(block);
    case "Text":
      return initialTextState(block, parentEnv);
    case "Group":
      return initialGroupState(block, parentSchema, parentEnv);
    case "Repeat":
      return initialRepeatState(block, parentSchema, parentEnv);
    case "RequireRole":
      return initialRequireRoleState(block, parentSchema, parentEnv);
    case "Scope":
      return initialScopeState(block, parentSchema, parentEnv);
    case "Visibility":
      return initialVisibilityState(block, parentSchema, parentEnv);
    case "PrimarySurveyorField":
      return initialPrimarySurveyorFieldState(block, parentSchema, parentEnv);
    case "PrimaryTeamField":
      return initialPrimaryTeamFieldState(block, parentSchema, parentEnv);
    default:
      return initialFieldState(block, parentEnv);
  }
}
function initialPageState(page, formSchema, formEnv) {
  const pageSchema = import_fp.Option.wrap(formSchema).nullMap((s) => (0, import_topo_survey.schemaRef)(s, page.path)).getOrThrow(() => new Error("Page schema not found"));
  const pageEnv = formEnv.focus(page.path);
  const blockStates = page.blocks.flatMap((block) => {
    return initialBlockState(block, pageSchema, pageEnv);
  });
  const counts = (0, import_message.pageMessageCounts)(blockStates);
  const highlight = (0, import_message.messageHighlight)(counts);
  const enabled = (0, import_run.optTopoEval)(page.enabled, pageEnv).getOrUndefined() ?? true;
  return { page, blockStates, enabled, highlight, ...counts };
}
function initialFormState(form, schema, document) {
  const pageStates = form.pages.map((page) => initialPageState(page, schema, import_topo_core.Env.create(document)));
  const errorCount = pageStates.reduce((total, pageState) => total + pageState.errorCount, 0);
  const infoCount = pageStates.reduce((total, pageState) => total + pageState.infoCount, 0);
  return { form, document, pageStates, errorCount, infoCount };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  initialBlockState,
  initialCardState,
  initialDynamicGridState,
  initialDynamicImageState,
  initialDynamicValueState,
  initialFieldState,
  initialFormState,
  initialFullWidthState,
  initialGroupState,
  initialHeadingState,
  initialPageState,
  initialPrimarySurveyorFieldState,
  initialPrimaryTeamFieldState,
  initialRepeatState,
  initialRepeatStateFromArray,
  initialRequireRoleState,
  initialScopeState,
  initialTextState,
  initialVisibilityState
});
//# sourceMappingURL=initial.js.map
